var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 71,
    viewBox: "0 0 108 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.6788 26.5473C83.6555 11.4598 70.1839 0.133301 54.0002 0.133301C41.1511 0.133301 29.9915 7.30531 24.4339 17.8009C11.0512 19.2004 0.647461 30.352 0.647461 43.8651C0.647461 58.3403 12.6074 70.1041 27.3238 70.1041H85.1227C97.3938 70.1041 107.353 60.3082 107.353 48.2383C107.353 36.6931 98.2386 27.3345 86.6788 26.5473Z",
    fill: "#003A27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8256 34.1885L55.8256 56.0415L52.175 56.0415L52.175 34.1885L42.3843 43.8188L39.8034 41.2801L54.0003 27.3159L68.1973 41.2801L65.6163 43.8188L55.8256 34.1885Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.c986b784f05d4b0264379f3d831be902.svg";
export { ForwardRef as ReactComponent };